import { api } from "@/api/client";

// The Messenger PWA runs in one of two separate spaces: "private" or "work".
// Every messaging call is scoped to the active space so the two circles stay
// fully separated (own chats, groups and contacts). The website P2P (via a
// profile) always uses "private".
let _space = "private";
export const setMessengerSpace = (s) => { _space = s === "work" ? "work" : "private"; };
export const getMessengerSpace = () => _space;
const sp = () => `space=${_space}`;

export const messagingApi = {
  // P2P
  threads: () => api.get(`/messaging/threads?${sp()}`).then((r) => r.data),
  openThread: (target_user_id) => api.post(`/messaging/threads/open?${sp()}`, { target_user_id }).then((r) => r.data),
  createGroup: (participant_ids, title) => api.post(`/messaging/threads/group?${sp()}`, { participant_ids, title }).then((r) => r.data),
  addParticipants: (tid, user_ids) => api.post(`/messaging/threads/${tid}/participants`, { user_ids }).then((r) => r.data),
  threadMessages: (tid) => api.get(`/messaging/threads/${tid}/messages`).then((r) => r.data),
  sendMessage: (tid, text) => api.post(`/messaging/threads/${tid}/messages`, { text }).then((r) => r.data),
  closeThread: (tid) => api.post(`/messaging/threads/${tid}/close`).then((r) => r.data),

  // Group rooms
  rooms: () => api.get(`/messaging/rooms?${sp()}`).then((r) => r.data),
  createRoom: (payload) => api.post(`/messaging/rooms?${sp()}`, payload).then((r) => r.data),
  joinRoom: (rid) => api.post(`/messaging/rooms/${rid}/join`).then((r) => r.data),
  roomMessages: (rid) => api.get(`/messaging/rooms/${rid}/messages`).then((r) => r.data),
  sendRoomMessage: (rid, text) => api.post(`/messaging/rooms/${rid}/messages`, { text }).then((r) => r.data),

  // Team
  team: () => api.get(`/messaging/team?${sp()}`).then((r) => r.data),

  // Per-space contacts (Messenger PWA)
  contacts: () => api.get(`/messaging/contacts?${sp()}`).then((r) => r.data),
  addContact: (contact_user_id) => api.post(`/messaging/contacts?${sp()}`, { contact_user_id }).then((r) => r.data),
  removeContact: (contact_user_id) => api.delete(`/messaging/contacts/${contact_user_id}?${sp()}`).then((r) => r.data),
};
